<template>
  <b-modal size="lg" centered id="invite-modal" title="Invite User" hide-footer>
    <validation-observer v-slot="{ invalid }" ref="formValidator">
      <form class="needs-validation" ref="communityTrackingForm"
            @submit.prevent="addUser">
        <b-row>
          <b-col md="6">
            <base-input label="Member" label-for="member" name="Member" rules="required">
              <el-select v-model="member" placeholder="Select a Member">
                <el-option v-for="(member, key) in members"
                           :key="key"
                           :label="member.name"
                           :value="member.email">
                </el-option>
                <el-option value="newUser" label="New User"></el-option>
              </el-select>
            </base-input>
            <div v-if="member == 'newUser'">
              <b-form-group label="Name" label-class="form-control-label">
                <b-form-input v-model="form.name" name="name" required></b-form-input>
              </b-form-group>

              <b-form-group label="Email" label-class="form-control-label">
                <b-form-input type="email" v-model="form.email" name="email" required></b-form-input>
              </b-form-group>
            </div>
          </b-col>
          <b-col md="6">
            <base-input label="Role" label-for="member" name="Role" rules="required">
              <el-select v-model="form.role_id">
                <el-option :value="null" label="Select a Role"></el-option>
                <el-option v-for="(role, key) in roles"
                           :key="key"
                           :label="role.name | capitalize"
                           :value="role.id">
                    <div class="option-grid prefix">
                      <div class="option-name"><strong>{{ role.name | capitalize }}</strong></div>
                      <div class="option-description">{{ role.description }}</div>
                    </div>
                </el-option>
              </el-select>
            </base-input>
            <base-input label="Team Role" label-for="team_role" v-if="teamRole">
              <el-select v-model="form.team_role" required>
                <el-option :value="null" label="Select a Team Role"></el-option>
                <el-option value="Admin" label="Admin"></el-option>
                <el-option value="Coach" label="Coach"></el-option>
                <el-option value="Other" label="Other"></el-option>
              </el-select>
            </base-input>
          </b-col>
        </b-row>
      
        <div v-if="form.role_id == 4 && chargeForAgent">
          <p class="text-danger text-center"><em>There is a ${{ agentPrice }}/mo charge for each additional Agent.</em></p>
        </div>
        <div v-if="form.role_id == 4 && chargeForAgent && user.card_brand == null && !user.is_grandfathered">
          Add payment method
          <payment-methods></payment-methods>
        </div>
        <div class="text-right">
          <b-button variant="success" type="submit" :disabled="disabled">Invite User</b-button>
        </div>
      </form>
    </validation-observer>
    <ul v-if="errorList" class="text-danger">
      <li v-for="(error, index) in errorList" :key="index">{{ error }}</li>
    </ul>
  </b-modal>
</template>

<script>
import axios from 'axios';
import errorsMixin from '@/mixins/errors-mixin';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import {Select, Option} from 'element-ui';
import PaymentMethods from '@/views/Portal/Account/PaymentMethods';

export default {
  mixins: [errorsMixin],
  props: {
    members: null,
    userRoute: null,
    roles: null
  },
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    PaymentMethods
  },
  data() {
    return {
      member: null,
      form: {
        name: null,
        email: null,
        role_id: null,
        team_role: null
      },
      inviteFields: ['name', 'email', 'role', 'token', { key: 'actions', label: '' }],
      errorList: null
    }
  },
  computed: {
    user() {
      return this.$store.getters['profile/user'];
    },
    selected() {
      if(this.member !== null) {
        return this.members.filter(member => {
          return member.email == this.member;
        })[0];
      }

      return this.member;
    },
    teamRole() {
      const roles = [5, 6];
      return roles.includes(this.form.role_id);
    },
    subBasic() {
      return this.user.subscription == process.env.VUE_APP_STRIPE_BASIC;
    },
    subStandard() {
      return this.user.subscription == process.env.VUE_APP_STRIPE_STANDARD;
    },
    chargeForAgent() {
      return (this.subBasic || this.subStandard) && !this.user.enterprise && !this.user.enterprise_created;
    },
    agentPrice() {
      if(this.subBasic) {
        return 10;
      } else if (this.subStandard && !this.user.enterprise) {
        return 5;
      } else {
        return 0;
      }
    },
    disabled() {
      if (this.form.role_id == 4 && this.chargeForAgent && this.user.card_brand == null && !this.user.is_grandfathered) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    mapUser() {
      if(this.member !== 'newUser') {
        this.form.name = this.selected.name;
        this.form.email = this.selected.email;
      } else {
        this.resetForm();
      }
    },
    async addUser() {
      this.errorList = null;
      const isValid = await this.$refs.formValidator.validate();
      if(!isValid) {
        this.errorList = Object.values(this.$refs.formValidator.errors).flat();
      } else {
        await axios.post(this.userRoute + "/invites", this.form)
        .then(response => {
          swal.fire({
            title: `Success`,
            text: response.data,
            showConfirmButton: false,
            timer: 1750,
            icon: 'success'
          });
          this.$emit('getInvites');
          this.resetForm();
          this.$bvModal.hide('invite-modal');
        })
        .catch(error => {
          this.error(error);
        });
      }
    },
    resetForm() {
      this.form.name = null;
      this.form.email = null;
      this.form.role_id = null;
    }
  },
  watch: {
    member(to, from) {
      this.mapUser();
    }
  }
};
</script>
<style lang="scss">
.el-select-dropdown__item {
  height: max-content;
}
.option-grid {
  margin-top: .5rem;
  margin-bottom: .5rem;
}
.option-name {
  line-height:100%;
}
</style>